import React from 'react';
import orderClose from 'src/assets/img/order-closed.png';

import { GridCellProps } from '@progress/kendo-react-grid';

import orderOpen from 'src/assets/img/order-ok.png';

const Status: React.ComponentType<GridCellProps> = (props) => {
  const field = props.field || '';
  const value = props.dataItem[field];

  return (
    <td
      title={value}
      onClick={() => {
        props.selectionChange?.(props.dataItem);
        props.onChange?.(props.dataItem);
      }}
    >
      <div className="flex items-center">
        {value === 'Open' ? (
          <>
            <img src={orderOpen} alt="Open icon" data-tooltip="Accept/Open" />
            <span className="ml-2"> Open</span>
          </>
        ) : (
          <>
            <img src={orderClose} alt="Close icon" data-tooltip="Completed/Closed" />
            <span className="ml-2"> Closed</span>
          </>
        )}
      </div>
    </td>
  );
};
export default Status;
